import {
    ValueProps as RTSP
} from '@mulesoft/monitoring-center-components/lib/components/Selector/EnvironmentSelector/EnvironmentSelector'

export type BasicTarget = {
    id: string
    name: string
}

export const TARGET_RESOURCE_NAME = 'resource_target'
export const TARGET_PREFIX = 'MONITORING'

export type ResourceTargetSelectorProps = RTSP
